import script from "./NotificationManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationManagement.vue?vue&type=script&setup=true&lang=js"

import "./NotificationManagement.vue?vue&type=style&index=0&id=e864da48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e864da48"]])

export default __exports__